module.exports = __webpack_public_path__ + "img/mallikuva7.df98a40a.jpg";